<template>
  <div class="q-echart">
    <div class="topContent">
      <div class="title">Labour Trends</div>
      <div class="rightContent">
        <div class="legend">
          <span class="legend1">Target</span>
          <span class="legend2">Actual</span>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="chartsContent2">
        <ECharts ref="lineChart" :option="lineOptions" id="chart" class="lineChart2"></ECharts>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ECharts from 'vue-echarts';
import 'echarts';

export default {
  name: 'Home',
  components: {ECharts},
  props: {
    current: {
      type: String,
      default: 'Cost'
    },
    datum: {
      type: Object,
      default: {}
    },
    showDeputyCycle: {
      type: Boolean,
      default: false
    },
    weekStart: {
      type: Number,
      default: 0
    },
  },
  data(){
    return {
      weekDays:[],
      lineOptions:{
        color: ["#ffffff","#2FCBFF"],//颜色配置
        tooltip: {//鼠标经过的提示
          backgroundColor: '#EA3796',
          borderColor: '#EA3796',
          trigger: 'axis',
          textStyle: {
            color: 'white',
            'fontFamily': 'PingFang SC-Regular, PingFang SC'
          },
          trigger: 'axis',
          axisPointer: {type: 'line'},
          valueFormatter:value => {
            let num = parseFloat(value),
              valueText = (num.toString().indexOf ('.') !== -1) ?num.toLocaleString():num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            return this.current === 'Cost' ? `$${valueText}` : `${value}h`;
          }
        },
        grid: {
          top: '5%',
          left: '4%',
          right: '3%',
          bottom: '8%'
        },
        legend: {//图例
          show:false,
          right: 30,
          icon:'circle',
          position:'right',
          data: ['Target', 'Actual'],
        },
        xAxis: [{//x轴
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show:false, //隐藏x轴刻度
            alignWithLabel: true
          },
          axisLabel:{
            fontFamily: 'PingFang SC-Medium',
            color: '#657291',//设置刻度数值颜色
            margin: 13,//设置数值跟轴的间距
          },
          // data: ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"]
          data: ["","","","","","",""]
        }],
        yAxis: [{//y轴
            type: 'value',
            axisLine: {show: false,},
            splitLine :{
              lineStyle:{
                opacity:0.1
              },
              show: true 
            },
            axisLabel:{
              color: '#657291',//设置刻度数值颜色
              fontFamily: 'PingFang SC-Medium',
              formatter(val){//设置y轴刻度展示形式
                return val > 1000? val/1000+'k':val;
              }
            }
        }],
        series: [//数据格式
          {
            name: 'Target',
            type: 'line',
            // data: [2000,8000,6000,11,1000,1222,1212],\
            data: [0, 0, 0, 0, 0, 0, 0],
            smooth: true,
            showSymbol: false,
          },
          {
            name: 'Actual',
            type: 'line',
            // data: [111,444,5555,77,111,88,555],
            data: [0, 0, 0, 0, 0, 0, 0],
            smooth: true,
            showSymbol: false,
          }
        ],

        cost: [],
        hour: []
    },
    }
  },
  mounted() {
    window.addEventListener("resize",()=>{//监听窗口改变调节图表
      if(this.$refs.lineChart){
        this.$refs.lineChart.resize();
      }
    });
    // this.initFn();
  },
  methods: {
    initFn(cost, hour){//初始事件
      const order = !this.showDeputyCycle
      const weekStart = this.weekStart
      const dates = [
          {code:1,title:"Mon",isDisable:false},
          {code:2,title:"Tue",isDisable:false},
          {code:3,title:"Wed",isDisable:false},
          {code:4,title:"Thu",isDisable:false},
          {code:5,title:"Fri",isDisable:false},
          {code:6,title:"Sat",isDisable:false},
          {code:7,title:"Sun",isDisable:false}
        ];
      const nowDay = new Date(),curDay = nowDay.getDay() === 0 ? 7 : nowDay.getDay();//获取当天是周几
      let weekDays = [];
      //["Mon","Tue","Wed","Thu","Fri","Sat","Sun"]
      if(order){//正序
        weekDays = dates;
        const dayIndex = weekDays.findIndex(item =>item.code === curDay);//获取本周已到跟未到的日期分割索引
        weekDays.forEach((item,index) => {
          if(index<=dayIndex){
            item.isDisable = false;
          }else{
            item.isDisable = true;
          }
        })
      }else{//乱序
        const num = dates.findIndex(item =>item.code === weekStart);//获取分割上周本周的索引
        const newDays1 = dates.filter((item,index) => index>=num);//上周数据
        const newDays2 = dates.filter((item,index) => index<num);//本周数据
        const dayIndex = dates.findIndex(item =>item.code === curDay);//获取本周已到跟未到的日期分割索引
        if(dayIndex||dayIndex===0){
          newDays2.forEach((item,index) => {
            if(index<=dayIndex){
              item.isDisable = false;
            }else{
              item.isDisable = true;
            }
          })
        }
        weekDays = [...newDays1,...newDays2];
      }
      this.weekDays = weekDays;

      this.getChartFn(order, weekDays, cost, hour);
    },
    getChartFn(order, weekDays, cost, hour){
      // 如果不乱序
      if (order) {
        // console.log('456')
        let arr = []
        if (this.current === 'Cost') {
          arr = cost
        } else {
          arr = hour
        }
        this.lineOptions.series = arr
        this.lineOptions.xAxis[0].data = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"]
      }
      else {
        // console.log('789')
        let actual = []
        let target = []
        if (this.current === 'Cost') {
          actual = cost[1].data
          target = cost[0].data
        } else {
          actual = hour[1].data
          target = hour[0].data
        }
        let final = [
          {
            name: 'Target',
            type: 'line',
            data: [target[weekDays[0].code - 1], target[weekDays[1].code - 1], target[weekDays[2].code - 1],
            target[weekDays[3].code - 1], target[weekDays[4].code - 1], target[weekDays[5].code - 1],
            target[weekDays[6].code - 1]],
            smooth: true,
            showSymbol: false,
          },
          {
            name: 'Actual',
            type: 'line',
            data: [actual[weekDays[0].code - 1], actual[weekDays[1].code - 1], actual[weekDays[2].code - 1],
            actual[weekDays[3].code - 1], actual[weekDays[4].code - 1], actual[weekDays[5].code - 1],
            actual[weekDays[6].code - 1]],
            smooth: true,
            showSymbol: false,
          }
        ]
        this.lineOptions.series = final

        this.lineOptions.xAxis[0].data = [weekDays[0].title, weekDays[1].title, weekDays[2].title, weekDays[3].title,
        weekDays[4].title, weekDays[5].title, weekDays[6].title]
      }
      // console.log(this.current)
      // console.log('878787')
      this.$refs.lineChart.resize()
    },  
    dayChange(e, boo){//选择日期
      if (!boo)
        this.curDay = e
    }
  },
  watch: {
    datum: {
      deep: true,
      handler: function (val) {
        let final_cost = []
        let final_hour = []
        // 选中cost的数据Start ****************************
        let targetCost = val.targetWeekDayProportionPojo_cost ? val.targetWeekDayProportionPojo_cost : 
        {fri: 0,mon: 0,sat: 0,sun: 0,thu: 0,tue: 0,wed: 0}
        targetCost = {
          fri: targetCost.fri ? targetCost.fri : 0,
          mon: targetCost.mon ? targetCost.mon : 0,
          sat: targetCost.sat ? targetCost.sat : 0,
          sun: targetCost.sun ? targetCost.sun : 0,
          thu: targetCost.thu ? targetCost.thu : 0,
          tue: targetCost.tue ? targetCost.tue : 0,
          wed: targetCost.wed ? targetCost.wed : 0
        }
        final_cost.push({
          name: 'Target',
          type: 'line',
          data: [targetCost.mon, targetCost.tue, targetCost.wed, targetCost.thu, targetCost.fri, targetCost.sat, targetCost.sun],
          smooth: true,
          showSymbol: false,
        })

        let actualCost = val.actualWeekDayProportionPojo_cost ? val.actualWeekDayProportionPojo_cost : 
        {fri: 0,mon: 0,sat: 0,sun: 0,thu: 0,tue: 0,wed: 0}
        actualCost = {
          fri: actualCost.fri ? actualCost.fri : 0,
          mon: actualCost.mon ? actualCost.mon : 0,
          sat: actualCost.sat ? actualCost.sat : 0,
          sun: actualCost.sun ? actualCost.sun : 0,
          thu: actualCost.thu ? actualCost.thu : 0,
          tue: actualCost.tue ? actualCost.tue : 0,
          wed: actualCost.wed ? actualCost.wed : 0
        }
        final_cost.push({
          name: 'Actual',
          type: 'line',
          data: [actualCost.mon, actualCost.tue, actualCost.wed, actualCost.thu, actualCost.fri, actualCost.sat, actualCost.sun],
          smooth: true,
          showSymbol: false,
        })

        this.cost = final_cost
        // 选中cost的数据End ****************************

        // 选中hour的数据Start ****************************
        let targetHour = val.targetWeekDayProportionPojo_time ? val.targetWeekDayProportionPojo_time : 
        {fri: 0,mon: 0,sat: 0,sun: 0,thu: 0,tue: 0,wed: 0}
        targetHour = {
          fri: targetHour.fri ? targetHour.fri : 0,
          mon: targetHour.mon ? targetHour.mon : 0,
          sat: targetHour.sat ? targetHour.sat : 0,
          sun: targetHour.sun ? targetHour.sun : 0,
          thu: targetHour.thu ? targetHour.thu : 0,
          tue: targetHour.tue ? targetHour.tue : 0,
          wed: targetHour.wed ? targetHour.wed : 0
        }
        final_hour.push({
          name: 'Target',
          type: 'line',
          data: [targetHour.mon, targetHour.tue, targetHour.wed, targetHour.thu, targetHour.fri, targetHour.sat, targetHour.sun],
          smooth: true,
          showSymbol: false,
        })

        let actualHour = val.actualWeekDayProportionPojo_time ? val.actualWeekDayProportionPojo_time : 
        {fri: 0,mon: 0,sat: 0,sun: 0,thu: 0,tue: 0,wed: 0}
        actualHour = {
          fri: actualHour.fri ? actualHour.fri : 0,
          mon: actualHour.mon ? actualHour.mon : 0,
          sat: actualHour.sat ? actualHour.sat : 0,
          sun: actualHour.sun ? actualHour.sun : 0,
          thu: actualHour.thu ? actualHour.thu : 0,
          tue: actualHour.tue ? actualHour.tue : 0,
          wed: actualHour.wed ? actualHour.wed : 0
        }
        final_hour.push({
          name: 'Actual',
          type: 'line',
          data: [actualHour.mon, actualHour.tue, actualHour.wed, actualHour.thu, actualHour.fri, actualHour.sat, actualHour.sun],
          smooth: true,
          showSymbol: false,
        })

        this.hour = final_hour
        // 选中hour的数据End ****************************
        this.initFn(this.cost,this.hour)
      }
    }
  }
}
</script>

<style lang="scss" src="@/assets/css/echart.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/component/weeklyEchart.vue